export const SET_BUN: 'SET_BUN' = 'SET_BUN';
export const ADD_INGREDIENT: 'ADD_INGREDIENT' = 'ADD_INGREDIENT';
export const REMOVE_INGREDIENT: 'REMOVE_INGREDIENT' = 'REMOVE_INGREDIENT';
export const REMOVE_INGREDIENTS: 'REMOVE_INGREDIENTS' = 'REMOVE_INGREDIENTS';
export const MOVE_INGREDIENT: 'MOVE_INGREDIENT' = 'MOVE_INGREDIENT';
